export default "__VITE_ASSET__171c2dec__"